import React, { useState } from 'react'
import { FieldDataListStrings as Strings } from '../../../utils/config'
import ListEntry from './ListEntry'


const SubListEntry = ({ dataFields, dataFieldValues }) => {

    const [listExpanded, setListExpanded] = useState(false);
    const fieldValuesExist = dataFieldValues && dataFieldValues.length > 0
    const expandText = listExpanded ? Strings.collapseList : Strings.expandList

    const baseClassName = 'td-list-entry'
    const expandedClassName = fieldValuesExist ? `${baseClassName}-expand-text` : `${baseClassName}-no-data-text`

    const onExpandTextClick = () => {
        setListExpanded(!listExpanded)
    }

    const renderSubListEntry = () => {
        if (listExpanded && fieldValuesExist) {
            return (dataFieldValues.map((value, index) =>
                <div className={`${baseClassName}-sublist-entry`}>
                    <ListEntry
                        entryKey={index}
                        dataFields={dataFields}
                        dataFieldValues={value}
                    />
                </div>
            ))
        }
        return null;

    }

    return (
        <div className={fieldValuesExist && listExpanded && `${baseClassName}-sublist`}>
            <span className={`${baseClassName}-data-field-value ${expandedClassName} col-6`} onClick={onExpandTextClick}>
                {fieldValuesExist ? expandText : Strings.noData}
            </span>
            {renderSubListEntry()}
        </div>
    )

};

export default SubListEntry;
